import { t } from "@repo/translation";
import { type Toast } from "@repo/utils";

export const handleDrawingLinkCopy = async (
  viewUrl: string,
  updateToast: (toast: Toast) => void
) => {
  try {
    await navigator.clipboard.writeText(viewUrl);

    updateToast({
      title: t("prompt.drawing_link_has_been_copied"),
    });
  } catch {
    updateToast({
      type: "error",
      title: t("prompt.something_went_wrong"),
    });
  }
};
